<template lang="html">
  <div style="width: auto; height: auto; ">
    <video ref="promovideo" width="100%" height="90%" style="display: block; margin: auto;" controls autoplay>
      <source src="https://mapletone.com/leifpark/video/LEIF_park_promo1.mp4" type="video/mp4">
        Your browser does not support mp4 video.
    </video>
  </div>
</template>

<script>
export default {
  mounted () {
  },
  destroyed () {
  }
}
</script>

<style lang="css">
</style>
